
import ScriptingEffect from './ScriptingEffect.js';
import {pipe} from './pipe.js';
import {altn} from './alt.js';
import {
    switchOutput,
    execute,
    notes,
    steps,
    prob,
} from './lang.js';

class AltNEffect extends ScriptingEffect {
    constructor(track) {
        super("Alternate N", track);
        this.newVar("steps", 16, 1, 64);
        this.newVar("outputs", 2, 1, 8);
        this.clear();
    }

    set value(x) {
        this.outputsParameter.set(x);
    }

    get value() {
        return this.outputsParameter.get();
    }

    get documentation() {
        return [
            "Alternates between the outputs of this effect every few steps."
        ];
    }

    get numberOfOutputs() {
        if (this.outputsParameter) {
            let x = Math.floor(this.var("outputs")());
            return isNaN(x) ? 2 : x;
        } else {
            return 2;
        }
    }

    set numberOfOutputs(s) {
    }

    isRealTime() {
        return false;
    }

    clear() {
        let outputs = [];
        for (let i=0; i < this.numberOfOutputs; i++) {
            outputs.push(switchOutput(i));
        }
        this.myScript = pipe(
            altn(this.var("steps"), ...outputs));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track, ignoreId=true) {
        let fx = new AltNEffect(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}


export default AltNEffect;
